var SENTRY_RELEASE;SENTRY_RELEASE={name: "Lissen", version: "4.2.29"};